import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from './modules/login';
import { environment } from 'src/environments/environment';
import { SnackSuccessComponent } from './components/snack-success/snack.success';
import { SnackErrorComponent } from './components/snack-error/snack.error';
import { AppDialogComponent } from './components/dialog/dialog.component';
import { SharedServiceModule } from './services';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxMaskModule } from 'ngx-mask';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { BnNgIdleService } from 'bn-ng-idle';
import { ScreenTrackingService, UserTrackingService } from '@angular/fire/compat/analytics';
import { MatIconModule } from '@angular/material/icon';
@NgModule({
  declarations: [
    AppComponent,
    SnackErrorComponent,
    SnackSuccessComponent,
    AppDialogComponent
  ],
  imports: [
    BrowserModule,
    MatIconModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatButtonModule,
    NgxMaskModule.forRoot(),
    NgxExtendedPdfViewerModule,
    LoginModule,
    MatDialogModule,
    AngularFirestoreModule,
    AngularFireModule.initializeApp(environment.firebase, 'CixEmployer'),
    AngularFireAuthModule,
    SharedServiceModule.forRoot(),
    MatProgressSpinnerModule,
    MatSnackBarModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    ScreenTrackingService,
    UserTrackingService,
    BnNgIdleService,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
